export enum SupportedExperiments {
  UsePromotionalContent = 'use-promotional-content'
}

export const EnabledCrossSellChargerProductTypes = [2430, 2694];

/**
 * Product types for which the new cases element is enabled.
 * These are the parent product types being tested, along with their accessories (cases):
 * - 2093: Smartphones
 * - 2101: Tablets
 */
export const EnabledAccessoryPreviewBlockProductTypes = [2093, 2101];

/**
 * Case product type IDs used by the AccessoryPreviewSection split test.
 */
export const MOBILE_CASES_PRODUCT_TYPE_ID = 2458;
export const TABLET_CASES_PRODUCT_TYPE_ID = 2453;
